import "@/design-system/styles.css";
// After the design system: adds safe-area insets without editing vendored files.
import "@/styles/app-shell.css";

import { createApp } from "vue";
import { registerSW } from "virtual:pwa-register";
import App from "./App.vue";

// autoUpdate: a new build takes over on the next navigation. No prompt -- an
// "update available" dialog is noise for a tool you open twice a season.
registerSW({ immediate: true });

createApp(App).mount("#app");
